var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.$can(_vm.constants.PERMISSION_GESTION_DROITS_REFERENT_LISTE) ? _c('div', {}, [_c('add-referent', {
    attrs: {
      "data-to-show": _vm.popupAddState
    },
    on: {
      "showChange": function (val) {
        _vm.changeStateAddReferentPopup(val);
      }
    }
  }), _vm._v(" "), _c('edit-referent', {
    attrs: {
      "data-to-show": _vm.isPopupEditReferentDisplayed,
      "is-admin-payer": _vm.isAdminPayer,
      "is-admin-entreprise": _vm.isAdminEntreprise
    },
    on: {
      "showChange": function (val) {
        _vm.changeStateEditReferentPopup(val);
      }
    }
  }), _vm._v(" "), _c('delete-referent', {
    attrs: {
      "data-to-show": _vm.popupDeleteState
    },
    on: {
      "showChange": function (val) {
        _vm.changeStateDeleteReferentPopup(val);
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex content-center items-center justify-between my-15 2xl:my-20 mx-5 lg:mx-15 2xl:mx-20"
  }, [_c('div', {
    staticClass: "flex flex-col items-center justify-center mt-5 w-full"
  }, [_c('div', {
    staticClass: "flex items-center justify-between w-full px-5 mb-2"
  }, [_vm.$can(_vm.constants.PERMISSION_GESTION_DROITS_REFERENT_AJOUTER) ? _c('add-button', {
    attrs: {
      "libelle": "Ajouter un référent"
    },
    on: {
      "add": function ($event) {
        return _vm.displayAddReferentPopup();
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "w-2/3 sm:w-1/3"
  }, [_c('search-bar', {
    attrs: {
      "name": "searchReferent",
      "libelle": "",
      "value": _vm.searchReferent,
      "placeholder": "Rechercher un référent",
      "big": false,
      "inherits": false,
      "has-border": false
    },
    on: {
      "input": function (newValue) {
        _vm.searchReferent = newValue;
      }
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "w-full px-5 flex items-center justify-end"
  }, [_c('sort-button', {
    attrs: {
      "sort": _vm.sort
    },
    on: {
      "sorted": function (sortType) {
        _vm.sort = sortType;
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "flex-shrink"
  })]), _vm._v(" "), _c('list-grid', {
    attrs: {
      "list-items": _vm.referentsSort
    },
    scopedSlots: _vm._u([_vm.referents.length > 0 ? {
      key: "header",
      fn: function () {
        return [_c('div', {
          staticClass: "col-start-1 xl:col-start-2 col-span-5 xl:col-span-3 ml-5 md:ml-10 xl:ml-0"
        }, [_vm._v("\n        Référents\n      ")]), _vm._v(" "), _c('div', {
          staticClass: "hidden xl:inline-block col-span-3"
        }, [_vm._v("\n        Rôles\n      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-span-5 xl:col-span-2"
        }, [_vm._v("\n        Accès rapide\n      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-span-2 mr-5 md:mr-10 truncate"
        }, [_vm._v("\n        Compte réf"), _c('span', {
          staticClass: "inline xl:hidden"
        }, [_vm._v(".")]), _c('span', {
          staticClass: "hidden xl:inline"
        }, [_vm._v("érent")])])];
      },
      proxy: true
    } : null, {
      key: "errorCases",
      fn: function () {
        return [_vm.referents.length > 0 && _vm.referentsSort.length === 0 ? _c('div', {
          staticClass: "flex flex-col justify-center items-center w-full"
        }, [_c('h3', {
          staticClass: "text-pink-600 w-full text-center font-semibold text-lg mt-12"
        }, [_vm._v("\n          Aucun résultat !\n        ")]), _vm._v(" "), _c('h4', {
          staticClass: "text-indigo-600 w-4/6 text-center text-base mt-8 mb-16"
        }, [_vm._v("\n          Aucun référent ne correspond à votre recherche, veuillez\n          réessayer avec de nouveaux éléments\n        ")]), _vm._v(" "), _c('div', [_c('illustration', {
          attrs: {
            "name": "no_result"
          }
        })], 1)]) : _vm._e(), _vm._v(" "), _vm.referents.length == 0 ? _c('div', {
          staticClass: "flex flex-col justify-center items-center w-full"
        }, [_c('h3', {
          staticClass: "text-pink-600 w-full text-center font-semibold text-lg mt-12"
        }, [_vm._v("\n          Aucun référent\n        ")]), _vm._v(" "), _c('h4', {
          staticClass: "text-indigo-600 w-4/6 text-center text-base mt-8 mb-16"
        }, [_vm._v("\n          Il n'y a aucun référent rattaché à votre structure\n        ")]), _vm._v(" "), _c('div', [_c('illustration', {
          attrs: {
            "name": "no_result"
          }
        })], 1)]) : _vm._e()];
      },
      proxy: true
    }, {
      key: "accordionDescription",
      fn: function (_ref) {
        var item = _ref.item;
        return [_c('div', {
          staticClass: "hidden xl:inline-block col-span-1 place-self-center"
        }, [_c('ProfilePicture', {
          attrs: {
            "size": "max-w-10 w-10 h-10",
            "other-object": item
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "col-span-5 xl:col-span-3 text-lg place-self-center justify-self-start ml-5 md:ml-10 xl:ml-0"
        }, [_vm._v("\n        " + _vm._s(item.firstname) + "\n        "), _c('span', {
          staticClass: "uppercase"
        }, [_vm._v(_vm._s(item.lastname))])]), _vm._v(" "), _c('div', {
          staticClass: "hidden xl:inline-block col-span-3 text-lg text-indigo-600 place-self-center justify-self-start"
        }, [item.roles.length > 0 ? _c('span', [_vm._v(_vm._s(item.roles[0].name))]) : _vm._e()]), _vm._v(" "), _c('div', {
          staticClass: "col-span-5 xl:col-span-2 place-self-center justify-self-start flex space-x-1"
        }, [_vm.$can(_vm.constants.PERMISSION_GESTION_DROITS_REFERENT_DROITS_SUR_NEOPASS) ? _c('router-link', {
          attrs: {
            "to": '/permissions/beneficiariesReferent/' + item.id,
            "title": "Gestion des droits sur les carnets de parcours du référent"
          }
        }, [_c('circle-button', {
          attrs: {
            "icon": "layers",
            "label": "Gestion des droits sur les carnets de parcours du référent",
            "enable-click": false
          }
        })], 1) : _vm._e(), _vm._v(" "), _vm.$can(_vm.constants.PERMISSION_GESTION_DROITS_REFERENT_SUPPRIMER) && _vm.user.id != item.id && item.roles[0].name != _vm.constants.ROLE_ADMIN_PAYEUR ? _c('circle-button', {
          attrs: {
            "icon": "close",
            "icon-scale": "75",
            "label": "Supprimer le référent"
          },
          on: {
            "buttonClick": function ($event) {
              return _vm.displayConfirmDeletePopup(item);
            }
          }
        }) : _vm._e()], 1), _vm._v(" "), _vm.$can(_vm.constants.PERMISSION_GESTION_DROITS_REFERENT_EDITER) ? _c('div', {
          staticClass: "col-span-2 place-self-center justify-self-start"
        }, [_c('action-button', {
          attrs: {
            "border-color": "border-transparent",
            "text-color": "text-gray-900",
            "bg-color": "bg-indigo-300",
            "bg-color-square": "bg-indigo-200",
            "icon-color": "text-indigo-600",
            "libelle": "Compte référent",
            "responsive": true,
            "icon": "edit"
          },
          on: {
            "clickAction": function ($event) {
              return _vm.displayEditRolePopup(item);
            }
          }
        })], 1) : _vm._e()];
      }
    }], null, true)
  })], 1) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }